// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__2l4oo","new-blog-button":"Dashboard_new-blog-button__P9313","button-icon":"Dashboard_button-icon__KmO5g"};